var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from "react";
import cx from "classnames";
import { getFullUrlPath } from "../../../utils";
import { getFullName, getInitials } from "../../../utils/identity";
import { userNavigationDefaultData as userNavData, } from "../defaultData";
import mainNavigationStyles from "./MainNavigation.module.scss";
import navigationItemStyles from "./NavigationItem.module.scss";
import styles from "./UserNavigation.module.scss";
import { clearUserBookingStorage } from "../../../utils/storage";
const hasWindow = () => {
    return typeof window === "object";
};
const visitorInteraction = "visitor interaction";
const navigationClick = "navigation click";
const pushNavItemAnalytics = (analytics) => (link) => {
    const data = Object.assign({ event: visitorInteraction, interactionName: navigationClick, linkType: "primary nav - my account" }, (link
        ? {
            linkPosition: link.position,
            linkPositionText: (link.name || "").toLowerCase(),
            linkRootPosition: undefined,
            linkRootText: undefined,
            linkSubPosition: undefined,
            linkSubPositionText: undefined,
            linkUrl: getFullUrlPath(link.url || ""),
        }
        : {}));
    analytics === null || analytics === void 0 ? void 0 : analytics(data);
};
function decorate(onClickAnalytics, menus = []) {
    return menus.map((menu, key) => (Object.assign(Object.assign({}, menu), { onClick: () => {
            onClickAnalytics(Object.assign(Object.assign({}, menu), { position: key + 1 }));
        } })));
}
const myAccount = {
    event: visitorInteraction,
    interactionName: navigationClick,
    linkType: "primary nav - my account",
    linkText: "my account",
    linkUrl: "/my-account",
};
const shortlisting = {
    event: visitorInteraction,
    interactionName: navigationClick,
    linkType: "primary nav - shortlisting",
    linkText: "Shortlisting",
    linkUrl: "/search-results/saved",
};
const baseLoginLink = `${myAccount.linkUrl}/login-registration`;
// pages where the login link isnt required to redirect back, will direct to dashboard
const excludedLoginLinkRedirects = [
    "/login-registration",
    "/create-account",
    "/search-results/saved",
];
const isRedirectPathExcluded = (path) => {
    return (excludedLoginLinkRedirects.filter((redirect) => path.includes(redirect))
        .length > 0);
};
const datadogPrivacyClass = "dd-privacy-mask";
export const UserNavigation = ({ submenu = userNavData, analytics = () => { }, userLoggedIn = false, userLogoutOnClick = () => { }, identity = undefined, setMenuOpen, isMenuOpen, }) => {
    var _a, _b;
    const [myAccountLoginLink, setMyAccountLoginLink] = useState(baseLoginLink);
    const pushAnalytics = pushNavItemAnalytics(analytics);
    const menuWithAnalytics = useMemo(() => decorate(pushAnalytics, submenu), [pushAnalytics, submenu]);
    const logoutClickHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        if (identity) {
            yield identity.clearIdentity();
        }
        clearUserBookingStorage();
        userLogoutOnClick();
        analytics({
            event: "visitor interaction",
            interactionName: "log out",
            successFlag: "success",
            authStatus: "logged out",
            authHavenId: null,
            authId: null,
            productType: "my_account",
            errorType: "no error",
        });
    });
    const isIdentifiedGuest = ((_b = (_a = identity === null || identity === void 0 ? void 0 : identity.identity) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.type) === "haven_guest";
    const initials = useMemo(() => {
        return getInitials(identity);
    }, [identity]);
    const fullname = useMemo(() => {
        return getFullName(identity);
    }, [identity]);
    useEffect(() => {
        hasWindow() &&
            !isRedirectPathExcluded(window.location.href) &&
            setMyAccountLoginLink(`${baseLoginLink}?returnUrl=${encodeURIComponent(window.location.href)}`);
    }, []);
    return (<nav className={cx(mainNavigationStyles.menu, mainNavigationStyles.userMenu)} aria-label={"account menu"}>
      <div className={styles.shortlistingNavigationWithChildren}>
        <a className={styles.shortlisting} href={shortlisting.linkUrl} onClick={() => analytics(shortlisting)}>
          <span className={styles.shortlistingLabel}>
            {shortlisting.linkText}
          </span>
        </a>
      </div>
      <div className={styles.userNavigationWithChildren}>
        <a className={styles.userMenuHeading} href={isIdentifiedGuest ? myAccount.linkUrl : myAccountLoginLink} onClick={() => analytics(myAccount)} data-testid={"user-navigation-link"}>
          <div className={cx(styles.userMenuHeadingText, datadogPrivacyClass)} data-testid={"user-navigation-heading"}>
            {fullname ? (<div>
                Welcome, <br />
                {fullname}
              </div>) : ("Log in / Sign up")}
          </div>
          <div className={styles.userMenuHeadingDropDown}></div>
          {identity && (<div className={cx(styles.avatar, { [styles.loggedOutAvatar]: !isIdentifiedGuest }, datadogPrivacyClass)}>
              {initials}
            </div>)}
        </a>
        {menuWithAnalytics && menuWithAnalytics.length && (<>
            {identity ? (<button aria-label={"open-account-menu"} onClick={() => setMenuOpen(!isMenuOpen)} className={cx(styles.mobileAvatar, styles.avatar, { [styles.loggedOutAvatar]: !isIdentifiedGuest }, datadogPrivacyClass)}>
                {initials}
              </button>) : (<button aria-label={"open-account-menu"} onClick={() => setMenuOpen(!isMenuOpen)} className={styles.mobileUserMenu}>
                Log in / Sign up
              </button>)}
            <div data-testid={"mobile-user-menu-contents"} className={cx(styles.listRightFixedWidth, { [styles.mobileOpen]: isMenuOpen }, "flexOnHover")}>
              {isIdentifiedGuest && (<div data-testid={"mobile-user-details"} key={"mobile-user-details"} className={cx(navigationItemStyles.listItem, navigationItemStyles.mobileOnly, datadogPrivacyClass)}>
                  <b>Welcome, {fullname}</b>
                </div>)}
              {!(userLoggedIn || isIdentifiedGuest) && (<div className={cx(navigationItemStyles.listItem)}>
                  <a data-testid={"mobile-myaccount-link"} className={navigationItemStyles.linkItem} href={`${myAccountLoginLink}`} onClick={() => analytics(myAccount)}>
                    Log in / Sign up
                  </a>
                </div>)}
              {menuWithAnalytics.map((child) => (<div key={child.name} className={navigationItemStyles.listItem}>
                  <a className={navigationItemStyles.linkItem} href={child.url} onClick={child.onClick}>
                    {child.name}
                  </a>
                </div>))}
              {(userLoggedIn || isIdentifiedGuest) && (<div key={"logout"} className={`${navigationItemStyles.listItem}`}>
                  <button data-testid={"logout-button"} className={cx(navigationItemStyles.linkItem, styles.logoutButton)} onClick={() => {
                    void logoutClickHandler();
                }}>
                    Log out
                  </button>
                </div>)}
            </div>
          </>)}
      </div>
    </nav>);
};
